const breakpoints = {
  PHONE: 640,
  TABLET: 768,
  DESKTOP: 1024
};
export default breakpoints;